/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Description_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Error exporting audio description. {error}" |
*
* @param {Audio_Description_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_failed_toast = /** @type {((inputs: Audio_Description_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de l'exportation de la description audio. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Exportieren der Audiobeschreibung. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'esportazione della descrizione audio. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при экспорте аудиоописания. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al exportar la descripción del audio. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出音频描述时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`音声説明のエクスポート中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो विवरण निर्यात करने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao exportar a descrição de áudio. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error exporting audio description. ${i?.error}`)
});